import { iconChevronLeft } from "@kensho/icons";
import { Button } from "@kensho/neo";
import { useNavigate } from "react-router";

import { APITranscript } from "../../../../types/types";
import { AudioQuality } from "./audio-quality";
import { SpeakerList } from "./speakers/speaker-list";

interface TranscriptLeftSidebarProps {
  transcript: APITranscript;
  version: number;
}

export function TranscriptLeftSidebar(props: TranscriptLeftSidebarProps) {
  const { transcript, version } = props;
  const navigate = useNavigate();
  return (
    <div className="mt-10 ml-2 flex flex-col gap-5">
      <div className="-ml-6">
        <Button
          minimal
          icon={iconChevronLeft}
          intent="primary"
          onClick={() => {
            navigate("/transcriptions");
          }}
        >
          Back to my transcripts
        </Button>
      </div>

      <AudioQuality accuracy={transcript.accuracy} />
      <div>
        <h4 className="mb-2 text-sm text-gray-500">Total Word Count</h4>
        <p className="text-lg font-semibold" data-testid="word-count">
          {transcript.sliceMeta.reduce(
            (total, slice) => total + slice.tokenMeta.length,
            0,
          )}
        </p>
      </div>
      <SpeakerList transcript={transcript} version={version} />
    </div>
  );
}
